module.exports = __webpack_public_path__ + "static/img/R14.8257472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/UltralowTemperature/R14.jpg
// module id = xvub
// module chunks = 1